//  Business partner photo
export const validPhotoExtension = ["image/jpeg", "image/jpg", "image/png"];

//  Business partner file_CV
export const validCvExtension = [
   "application/pdf",
   "application/msword",
   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
